/**
 * Module definition for magic module. The magic module manages
 * the application's top-level magic view (i.e., /magic).
 *
 * @module routes.magic
 */

angular.module('routes.magic', [
  'routes.magic.MagicController',
  'routes.magic.MagicPayloadResolver'
])
.config(
  [
    '$stateProvider',
    function ($stateProvider) {
      'use strict';

      $stateProvider
        .state('routes.magic', {
          url: '/magic',
          templateUrl: 'routes/magic/magic.html',
          controller: 'MagicController',
          params: {},
          resolve: {
            magicPayload: [
              'MagicPayloadResolver',
              '$stateParams',
              'newmanPayload',
              function (MagicPayloadResolver, $stateParams, newmanPayload) {
                return new MagicPayloadResolver($stateParams, newmanPayload);
              }
            ]
          }
        }
      );
    }
  ]
);
